import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "react-widgets/styles.css";
import Filters from "./components/Filters";
// import MapComponent from "./components/MapComponent";
import LoadMore from "./components/LoadMore";
import Preloader from "./components/Preloader";
import { fetchTeasers } from "./components/Helpers";
import { debounce } from "throttle-debounce";
import Grid from "./components/Grid";
import GridHighlight from "./components/GridHighlight";
import Promoted from "./components/Promoted";
import Slider from "./components/Slider";
import ReactPaginate from "react-paginate";

function FilterAppEvents({
  term,
  language,
  map,
  onlyPromoted,
  taxonomy,
  ajax,
  spotlight,
  data,
  type,
  numberItems,
  output,
  nodeId,
  fetchDataUrl,
  entityViewMode,
  itemsPerPage,
  showFilter,
}) {
  const paging = true;
  const [spotlightData, setSpotlightData] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [emptyFilters, setEmptyFilters] = useState({});
  const [showMap, setShowMap] = useState(false);
  const navigate = useNavigate();

  const [labels, setLabels] = useState([]);
  const [entities, setEntities] = useState([]);
  const [filters, setFilters] = useState([]);

  const [entitiesFiltered, setEntitiesFiltered] = useState([]);
  const [spotlightFiltered, setSpotlightFiltered] = useState([]);
  const [entitiesSliced, setEntitiesSliced] = useState([]);

  const [entitiesPromoted, setEntitiesPromoted] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);

  const [activeFilters, setActiveFilters] = useState(emptyFilters);
  const [teasers, setTeasers] = useState([]);

  const [loading, setLoading] = useState(true);
  const [loadingExtra, setLoadingExtra] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [init, setInit] = useState(true);

  const location = useLocation();

  useEffect(() => {
    // This effect will run whenever the query string changes
    const queryParams = new URLSearchParams(location.search);

    // Perform actions based on the query parameter
    //console.log("Query parameter changed:", myParam);

    Object.keys(filters).forEach((filterKey) => {
      let param = queryParams.get(filterKey);

      if (param) {
        param = param.split("_");

        for (var i = 0; i < param.length; i++) {
          Object.keys(filters[filterKey]).forEach((filter) => {
            const item = filters[filterKey][filter];
            if (item.label.toLowerCase() == param[i]) {
              if (!activeFilters[filterKey].includes(item.id)) {
                handleFilterChange(filterKey, item.id);
              }
            }
          });
        }
      }
    });

    // You can also trigger data fetching or other side effects here
  }, [location.search, filters]); // Dependency array includes location.search

  const limit = itemsPerPage;

  useEffect(() => {
    if (ajax) {
      fetch(
        fetchDataUrl +
          "?lang=" +
          language +
          "&nodeId=" +
          nodeId +
          "&taxonomy=" +
          taxonomy +
          "&type=" +
          type +
          "&promoted=" +
          onlyPromoted +
          "&limit=" +
          numberItems,
        {
          credentials: "include",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setLabels(data.labels);

          setEntities(data.data);

          ////

          let temp = [];
          Object.keys(data.filters).forEach((filterKey) => {
            temp.push(filterKey);
            emptyFilters[filterKey] = [];
          });

          setFilters(data.filters);

          setLoading(false);
          setTaxTypes(temp);

          setEmptyFilters(emptyFilters);
          setActiveFilters(emptyFilters);
        });
    } else {
      data = JSON.parse(data);

      setLabels(data.labels);

      setEntities(data.data);
      setTeasers(data.teasers);

      ////

      let temp = [];
      Object.keys(data.filters).forEach((filterKey) => {
        temp.push(filterKey);
        emptyFilters[filterKey] = [];
      });

      setFilters(data.filters);

      setLoading(false);
      setTaxTypes(temp);

      setEmptyFilters(emptyFilters);
      setActiveFilters(emptyFilters);
    }
  }, [ajax]);

  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    if (spotlight) {
      let result = JSON.parse(spotlight);

      let temp = [];

      if (result.nids) {
        Object.keys(result.nids).forEach((key) => {
          temp.push({ nid: result.nids[key] });
        });
      }

      result.items = temp;

      setSpotlightData(result);
    }
  }, [spotlight]);

  useEffect(() => {
    filterEntities();
  }, [entities, activeFilters, searchQuery, spotlight]);

  useEffect(() => {
    if (paging) {
      let extra = 0;
      let start = 0;

      setEntitiesSliced(
        [...entitiesFiltered].slice(
          itemOffset + start,
          itemOffset + limit + extra
        )
      );
    } else {
      setEntitiesSliced([...entitiesFiltered].slice(0, itemOffset + limit));
    }
  }, [entitiesFiltered, itemOffset, fetchDataUrl]);

  useEffect(() => {
    if (entitiesSliced) {
      //only request those who havent been requested before

      let temp = [];

      Object.keys(entitiesSliced).forEach((key) => {
        if (!teasers[entitiesSliced[key].nid]) {
          temp.push(entitiesSliced[key].nid);
        }
      });

      if (temp.length) {
        fetchTeasers(
          temp,
          setLoading,
          setLoadingExtra,
          itemOffset,
          teasers,
          language,
          output,
          itemsPerPage,
          entitiesPromoted,
          entityViewMode,
          setTeasers
        );
      }
    }
  }, [entitiesSliced]);

  const filterEntities = () => {
    let updatedEntities = [];
    let promoted = [];

    if (entities && entities.length) {
      promoted = entities.filter((entity) => {
        let entityShallPass = true;

        if (!entity.promoted) {
          entityShallPass = false;
        }
        return entityShallPass;
      });
      setEntitiesPromoted(promoted.slice(0, 4));

      updatedEntities = entities.filter((entity) => {
        let entityShallPass = true;

        Object.keys(activeFilters).forEach((filterKey) => {
          var one = true;

          let filterValue = activeFilters[filterKey];

          if (filterValue && filterValue.length > 0) {
            var f = false;
            for (var i = 0; i < filterValue.length; i++) {
              if (
                entity[filterKey] &&
                Array.isArray(entity[filterKey]) &&
                entity[filterKey].includes(filterValue[i])
              ) {
                f = true;
              }
            }

            if (!f) {
              one = false;
            }
          }

          if (!one) {
            entityShallPass = one;
          }
        });

        return entityShallPass;
      });

      setEntitiesFiltered(updatedEntities);

      let temp = [];

      if (spotlightData && spotlightData.data && spotlightData.data.length) {
        temp = spotlightData.data.filter((entity) => {
          let entityShallPass = true;

          Object.keys(activeFilters).forEach((filterKey) => {
            var one = true;

            let filterValue = activeFilters[filterKey];

            if (filterValue && filterValue.length > 0) {
              var f = false;
              for (var i = 0; i < filterValue.length; i++) {
                if (
                  entity[filterKey] &&
                  Array.isArray(entity[filterKey]) &&
                  entity[filterKey].includes(filterValue[i])
                ) {
                  f = true;
                }
              }

              if (!f) {
                one = false;
              }
            }

            if (!one) {
              entityShallPass = one;
            }
          });

          return entityShallPass;
        });
      }

      setSpotlightFiltered(temp);
    }
  };

  Array.prototype.remove = function () {
    var what,
      a = arguments,
      L = a.length,
      ax;
    while (L && this.length) {
      what = a[--L];
      while ((ax = this.indexOf(what)) !== -1) {
        this.splice(ax, 1);
      }
    }
    return this;
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);

    const newOffset = (event.selected * limit) % entitiesFiltered.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
    /* window.scrollTo({
      top: document.getElementById("react-top").offsetTop - 100,
    });*/
  };
  const handleFilterChange = (filterName, filterValue) => {
    const updatedFilters = { ...activeFilters };

    const queryParams = new URLSearchParams(location.search);

    let labels = [];

    if (Array.isArray(updatedFilters[filterName])) {
      //checkbox
      if (updatedFilters[filterName].includes(filterValue)) {
        updatedFilters[filterName].remove(filterValue);
      } else {
        updatedFilters[filterName].push(filterValue);
      }
    }

    Object.keys(filters[filterName]).forEach((filter) => {
      if (
        updatedFilters[filterName] &&
        updatedFilters[filterName].includes(filters[filterName][filter].id)
      ) {
        let label = filters[filterName][filter].label.toLowerCase();
        labels.push(label);
      }
    });

    if (labels.join("_") && filterValue != "all") {
      queryParams.set(filterName, labels.join("_"));
    } else {
      queryParams.delete(filterName);
    }

    navigate({
      pathname: location.pathname,
      search: queryParams.toString(),
      hash: "filters", // Add the anchor here
    });

    if (filterValue == "all") {
      updatedFilters[filterName] = [];
    }

    setActiveFilters(updatedFilters);
  };

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;

    setPageCount(Math.ceil(entitiesFiltered.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, entities, entitiesSliced]);

  const [bounds, setBounds] = useState([]);

  const boundsChanged = debounce(300, (map) => {
    let mapBounds = map.getBounds();

    const limitedBounds = map.unproject([0, 0]);

    const hDiff = Math.abs(mapBounds.getNorth() - limitedBounds.lat);
    const vDiff = Math.abs(mapBounds.getWest() - limitedBounds.lng);

    mapBounds = [
      mapBounds.getSouth() + hDiff,
      limitedBounds.lng,
      limitedBounds.lat,
      mapBounds.getEast() - vDiff,
    ];

    setBounds(mapBounds);
  });

  function resetFilters() {
    Object.keys(taxTypes).forEach((filterKey) => {
      handleFilterChange(taxTypes[filterKey], "all");
    });
  }

  return (
    <div>
      <div className="container  mx-auto ">
        {/* {showFilter && (
          <Filters
            taxTypes={taxTypes}
            filters={filters}
            map={map}
            setShowMap={setShowMap}
            showMap={showMap}
            type={type}
            taxonomy={taxonomy}
            labels={labels}
            resetFilters={resetFilters}
            handleFilterChange={handleFilterChange}
            activeFilters={activeFilters}
          />
        )} */}

        {map && entitiesFiltered && showMap && (
          <div className="mb-10 develop">
            {/*      
              <MapComponent
                entities={entitiesFiltered}
                onMove={boundsChanged}
                onZoom={boundsChanged}
              /> */}
          </div>
        )}
      </div>
      <div>
        <div className={"output output-" + output}>
          {loading ? (
            <Preloader />
          ) : (
            <div>
              {/* {showFilter && (
                <Promoted
                  spotlightData={spotlightData}
                  spotlightFiltered={spotlightFiltered}
                  type={type}
                  labels={labels}
                />
              )} */}

              {output === "slider" || output === "slider_one" ? (
                <div className="container relative mx-auto ">
                  <Slider
                    items={entitiesSliced}
                    labels={labels}
                    size={output == "slider" ? 4 : 1}
                    teasers={teasers}
                  />
                </div>
              ) : null}

              {output === "grid_highlight" ? (
                <div className="container relative mx-auto ">
                  <GridHighlight
                    columns={
                      entityViewMode == "list" || output == "list" ? 1 : 3
                    }
                    items={entitiesSliced}
                    labels={labels}
                    type={type}
                    teasers={teasers}
                  />
                </div>
              ) : null}

              {output === "grid" ? (
                <div className="container relative mx-auto ">
                  <Grid
                    columns={
                      entityViewMode == "list" || output == "list" ? 1 : 3
                    }
                    items={entitiesSliced}
                    labels={labels}
                    type={type}
                    teasers={teasers}
                  />
                </div>
              ) : null}
            </div>
          )}
        </div>

        {paging && entitiesFiltered.length > limit && (
          <div className={""}>
            <ReactPaginate
              onPageChange={handlePageClick}
              pageCount={pageCount}
              className={""}
              containerClassName={
                "v-flex v-justify-center v-items-center v-mb-20 v-gap-4"
              }
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              nextLinkClassName={"page-link next-link bg-icon"}
              previousLinkClassName={"page-link previous-link bg-icon"}
              activeClassName={"active"}
              forcePage={currentPage}
              previousClassName={"page-item"}
              nextClassName={"page-item"}
              renderOnZeroPageCount={null}
              previousLabel="<"
              nextLabel=">"
            />
          </div>
        )}

        {!paging && (
          <LoadMore
            entitiesFiltered={entitiesFiltered}
            itemOffset={itemOffset}
            setItemOffset={setItemOffset}
            itemsPerPage={itemsPerPage}
            loadingExtra={loadingExtra}
            labels={labels}
          />
        )}
      </div>
    </div>
  );
}

export default FilterAppEvents;
